/*
 * @Author: 肖玲
 * @Date: 2023-02-15 17:23:29
 * @LastEditTime: 2023-02-16 11:28:36
 * @LastEditors: 肖玲
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\router\business-order\system-settings\modules\systemSettingRouter.js
 * 系统设置
 */
const systemSettingRouter = [
  // 商务订单 系统配置
  {
    path: '/orderSystem/setting-list',
    name: 'orderSystemSettingList',
    component: () =>
      // import(
      //   /*webpackChunkName:"agreementSetting" */
      //   '@/views/orderSystem/setting/List'
      // ),
      import(
        /*webpackChunkName:"agreementSetting" */
        '@/views/business-order/system-settings/system-setting/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '系统设置',
    },
  },

  // 商务合同价新入口
  {
    path: '/orderSystem/goods-unit-price-page/:meta_type',
    name: 'orderSystemGoodsUnitPricePage',
    component: () =>
      // import(
      //   /*webpackChunkName:"orderSystemSetting" */
      //   '@/views/masterDataSystem/goods/unitPriceSetting/Page.vue'
      // ),
      import(
        /*webpackChunkName:"orderSystemSetting" */
        '@/views/business-order/system-settings/system-setting/commercial-contract-price/Page.vue'
      ),
    meta: {
      SecondaryMenu: '产品库', //二级菜单
      isMoreMeta: true,
      3: {
        title: '商务合同价',
        breadcrumb: [{
          title: '系统设置',
          name: 'orderSystemSettingList',
        }, ],
      },
    },
  },
  // 商务订单 系统配置 商务订单审批流设置
  {
    path: '/orderSystem/setting/approval',
    name: 'orderSystemSettingApproval',
    component: () =>
      // import(
      //   /*webpackChunkName:"agreementSetting" */
      //   '@/views/orderSystem/setting/Approval'
      // ),
      import(
        /*webpackChunkName:"agreementSetting" */
        '@/views/business-order/system-settings/system-setting/business-order-approval/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '商务订单审批流设置',
      breadcrumb: [{
        title: '系统设置',
        name: 'orderSystemSettingList',
      }, ],
    },
  },
]
export default systemSettingRouter